/* TypeTopia — keep their work (v1.1)
   v1.1 (2026-10-25, the face confetti page next; Ally's pick: "Yes, confetti and gift wrap share"): the face confetti
   page (and its gift tags and football shirt kinds) keeps its work too (confetti(), record "confetti" / "tags" /
   "shirtconfetti"); a section's own script, which runs before this file, hands itself over through window.TTKeepQ
   ([name, api] pairs, run as this loads, then at once). The faces they've cut out are shared: each in the list has
   the time it was first kept (t), and a page whose own record has no face of theirs, or is older than a face cut out
   since on another page, starts with that newest face (gift wrap: the face in use; confetti: only when it has none).
   v1 (2026-10-25, Ally: "if youve made wrap then go to somewhere else, when you come back to wrap, you're back to the
   start, same with bunting & confetti", then "make sure any new sections get this too"; her picks: kept a week on that
   device, back where they left off, the faces shared between confetti and gift wrap).

   assets/tt-keep.js, window.TTKeep: what a customer has made, kept in this browser for a week from its last save, so a
   page they come back to opens where they left it. Only links (their photos and cut-outs are uploaded as they're picked)
   and choices: no pictures, and nothing is sent anywhere. Every personaliser uses it, new ones too:
     get(key) / set(key, value) / patch(key, fields) / drop(key): a record (anything JSON can hold);
     onLeave(fn): fn runs as the page is left or hidden (pagehide, visibilitychange), to save what's on screen;
     faces() / addFaces(list): the faces they've cut out on any page, newest first, { c: cut-out link, o: photo link,
       t: first kept };
     wrapShared(): a new window.TTWrapShared (the gift wrap page's and the studio's shared state) with their name, age
       and size back at once and their faces once the pictures have loaded (.restoring: a promise of those faces);
     wrapSave(fields): window.TTWrapShared into the "wrap" record, with the page's own fields;
     confetti(api): the face confetti section's work kept and put back (its api: below).
   Records: "wrap", "confetti", "tags", "shirtconfetti", "shirtkit", "faces", and "bunting" (read and written by
   sections/tt-bunting.liquid v3.33 itself, in this format, before its first draw).
   localStorage "tt.keep.<key>" = { t: when saved, v: the record }. One that can't be read (private browsing, storage
   full or blocked, from an older version) is as if never kept: the page simply starts at the beginning. Nothing is kept
   or put back in the theme editor. */
(function () {
  "use strict";
  if (window.TTKeep) return;
  var PRE = "tt.keep.", WEEK = 7 * 864e5, MAX_FACES = 12;
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  function store() { try { return window.localStorage || null; } catch (e) { return null; } }
  function get(k) {
    var s = store(); if (!s) return null;
    try {
      var r = JSON.parse(s.getItem(PRE + k) || "null");
      if (!r || typeof r.t !== "number" || !(Date.now() - r.t < WEEK)) { if (r) s.removeItem(PRE + k); return null; }
      return r.v == null ? null : r.v;
    } catch (e) { return null; }
  }
  function set(k, v) {
    var s = store(); if (!s || EDITOR) return false;
    try { s.setItem(PRE + k, JSON.stringify({ t: Date.now(), v: v })); return true; } catch (e) { return false; }
  }
  function patch(k, o) {
    var v = get(k);
    if (!v || typeof v !== "object" || Array.isArray(v)) v = {};
    for (var x in o) if (Object.prototype.hasOwnProperty.call(o, x)) v[x] = o[x];
    return set(k, v);
  }
  function drop(k) { var s = store(); if (s) try { s.removeItem(PRE + k); } catch (e) {} }

  /* saving as they go: every page's savers, when the page is left (pagehide) or put away (a phone's app switch,
     another tab), which is the last moment a page can be sure of */
  var savers = [];
  function onLeave(fn) { if (typeof fn === "function") savers.push(fn); }
  function leave() { savers.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  window.addEventListener("pagehide", leave);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") leave(); });

  /* the faces: a link that can be loaded again (an uploaded cut-out), never a picture made in the browser */
  function isLink(u) { return /^https:\/\//.test(String(u || "")); }
  function faces() {
    var l = get("faces");
    return Array.isArray(l) ? l.filter(function (f) { return f && isLink(f.c); })
      .map(function (f) { return { c: f.c, o: isLink(f.o) ? f.o : "", t: typeof f.t === "number" ? f.t : 0 }; }) : [];
  }
  /* (v1.1) each face keeps the time it was first kept, so "newest" means the newest face, not the last save */
  function addFaces(list) {
    var now = Date.now(), had = {}, seen = {}, out = [], old = faces();
    old.forEach(function (f) { had[f.c] = f; });
    (list || []).concat(old).forEach(function (f) {
      if (!f || !isLink(f.c) || seen[f.c]) return;
      seen[f.c] = 1;
      out.push({ c: f.c, o: isLink(f.o) ? f.o : "", t: had[f.c] && had[f.c].t ? had[f.c].t : now });
    });
    out.sort(function (a, b) { return b.t - a.t; });
    set("faces", out.slice(0, MAX_FACES));
  }
  /* a face cut out on another page since this page's record was kept (or any, with no record): the newest */
  function newerFace(k) {
    var f = faces()[0];
    return f && (!k || (f.t || 0) > (k.when || 0)) ? f : null;
  }

  function loadImage(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = "anonymous";                  /* (the wraps bake from it, as from a new cut-out) */
      im.decoding = "async";
      im.onload = function () { res(im); };
      im.onerror = function () { rej(new Error("image")); };
      im.src = src;
    });
  }

  /* ── the gift wrap page and the studio ── */
  function str(v) { return typeof v === "string" ? v : ""; }
  function wrapShared() {
    var k0 = get("wrap"), k = k0 || {};
    var S = { faces: [], face: null, name: str(k.name).slice(0, 80), age: str(k.age).replace(/\D+/g, "").slice(0, 3),
              size: typeof k.size === "string" ? k.size : null };
    if (k.keep === false) S.keep = false;
    var list = (Array.isArray(k.faces) ? k.faces : []).filter(function (f) { return f && isLink(f.c); }).slice(0, MAX_FACES);
    var want = k.face;
    /* (v1.1) a face cut out since on another page (confetti): the face in use, first in their faces */
    var nf = newerFace(k0);
    if (nf && !list.some(function (f) { return f.c === nf.c; })) { list = [{ c: nf.c, o: nf.o }].concat(list).slice(0, MAX_FACES); want = nf.c; }
    S.restoring = !list.length ? Promise.resolve([]) : Promise.all(list.map(function (f) {
      return loadImage(f.c).then(function (img) { return { img: img, src: f.c, c: f.c, o: isLink(f.o) ? f.o : "", test: false, key: f.c }; },
                                  function () { return null; });              /* (a link that's gone: that face is left out) */
    })).then(function (fs) {
      fs = fs.filter(Boolean);
      /* theirs first, in their order; a face added while these loaded stays, after them */
      var have = {}; fs.forEach(function (f) { have[f.key] = 1; });
      S.faces = fs.concat(S.faces.filter(function (f) { return !have[f.key]; }));
      var by = function (c) { return S.faces.filter(function (f) { return f.key === c; })[0] || null; };
      if (!S.face) S.face = by(want) || (want && fs[0]) || null;
      if (!S.group && Array.isArray(k.group)) {
        var keys = k.group.filter(by);
        if (keys.length > 1 && S.face && keys[0] === S.face.key) S.group = { keys: keys, n: 1, kept: true };
      }
      S.restored = true;
      return fs;
    });
    return S;
  }
  function wrapSave(fields) {
    var S = window.TTWrapShared;
    if (!S) return;
    var fs = (S.faces || []).filter(function (f) { return f && !f.test && isLink(f.c); }).map(function (f) { return { c: f.c, o: isLink(f.o) ? f.o : "" }; });
    var rec = { faces: fs, face: S.face && !S.face.test && isLink(S.face.c) ? S.face.c : "",
                group: S.group && S.group.keys ? S.group.keys.filter(isLink) : null,
                name: str(S.name), age: str(S.age), size: S.size || null, keep: S.keep !== false, when: Date.now() };
    if (fields) for (var x in fields) if (Object.prototype.hasOwnProperty.call(fields, x)) rec[x] = fields[x];
    patch("wrap", rec);
    if (fs.length) addFaces(S.face && !S.face.test && isLink(S.face.c) ? [{ c: S.face.c, o: S.face.o }].concat(fs) : fs);
  }

  /* ── (v1.1) the face confetti page: sections/tt-face-confetti.liquid (v66.5) hands over
       { kind: "confetti" | "tags" | "shirtconfetti", shirt, state (faces, pack, mix, hold), ACCS, max, up (the first
         screen, hidden by the section till its faces are back), add (addFace), acc (loadAccImage), fonts
         (accFontsReady), pack(n) (a pack it sells), redo() (the pile or the tags drawn afresh) }
       Each face comes back with its accessory (by its block's id), its words, its placement for each accessory; then
       the pack and their mix of it. The football shirt's kit is kept by assets/tt-shirt-confetti.js ("shirtkit"). ── */
  function confetti(api) {
    var key = api.kind || "confetti", st = api.state, up = api.up;
    var unhide = function () { if (up) up.style.visibility = ""; };
    if (EDITOR || !st) { unhide(); return; }
    var k = get(key);
    onLeave(function () {
      var fs = (st.faces || []).filter(function (f) { return f && f.mode === "json" && isLink(f.cutoutUrl); }).map(function (f) {
        return { c: f.cutoutUrl, o: isLink(f.originalUrl) ? f.originalUrl : "", acc: f.acc && f.acc.id ? String(f.acc.id) : "", none: !!f.accNone,
                 text: f.accText || "", texts: f.accTexts || null, tf: f.tf || null, tfs: f.accTfs || null };
      });
      set(key, { faces: fs, pack: st.pack || null, mix: (st.mix || []).slice(), when: Date.now() });
      if (fs.length) addFaces(fs);
    });
    var setPack = function () { if (k && typeof k.pack === "number" && k.pack !== st.pack) api.pack(k.pack); };
    if (api.shirt) { setPack(); return; }
    var list = k && Array.isArray(k.faces) ? k.faces.filter(function (f) { return f && isLink(f.c); }) : [];
    if (!list.length) { var nf = newerFace(k); if (nf) list = [{ c: nf.c, o: nf.o }]; }    /* (a face from another page) */
    list = list.slice(0, api.max || 3);
    if (!list.length) { setPack(); unhide(); return; }
    st.hold = true;                                   /* (the pile waits till every face is back as it was) */
    var chain = Promise.resolve();
    list.forEach(function (f) {
      chain = chain.then(function () {
        return loadImage(f.c).then(function () {       /* (a link that's gone: that face quietly left out) */
          var d = { mode: "json", originalUrl: isLink(f.o) ? f.o : "", cutoutUrl: f.c };
          return Promise.resolve(api.add(d)).then(function () {
            if (st.faces.indexOf(d) < 0) return;
            var a = f.acc ? (api.ACCS || []).filter(function (x) { return String(x.id) === f.acc; })[0] : null;
            if (a) { d.acc = a; if (f.tf && typeof f.tf === "object") d.tf = f.tf; }
            else if (f.none) d.accNone = true;
            if (typeof f.text === "string") d.accText = f.text;
            if (f.texts && typeof f.texts === "object") d.accTexts = f.texts;
            if (f.tfs && typeof f.tfs === "object") d.accTfs = f.tfs;
          });
        }, function () {});
      });
    });
    chain.then(function () {
      setPack();
      var m = k && Array.isArray(k.mix) ? k.mix : null, sum = 0;
      if (m) m.forEach(function (n) { sum += n; });
      if (m && m.length === st.faces.length && sum === st.pack && m.every(function (n) { return n >= 1; })) st.mix = m.slice();
      var jobs = [api.fonts ? api.fonts() : null];
      st.faces.forEach(function (f) { if (f.acc) { jobs.push(api.acc(f.acc.src)); if (f.acc.backSrc) jobs.push(api.acc(f.acc.backSrc)); } });
      return Promise.all(jobs).catch(function () {});
    }).then(function () {
      st.hold = false;
      if (st.faces.length) api.redo();
      unhide();
    }, function () { st.hold = false; unhide(); });
  }

  window.TTKeep = { get: get, set: set, patch: patch, drop: drop, onLeave: onLeave, faces: faces, addFaces: addFaces,
                    wrapShared: wrapShared, wrapSave: wrapSave, confetti: confetti, loadImage: loadImage };

  /* (v1.1) sections whose script ran before this file: [name, api], run now; any later, at once */
  function run(x) { try { if (x && typeof window.TTKeep[x[0]] === "function") window.TTKeep[x[0]](x[1]); } catch (e) {} }
  var queued = Array.isArray(window.TTKeepQ) ? window.TTKeepQ : [];
  window.TTKeepQ = { push: run };
  queued.forEach(run);
})();
